/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Webhook_Token_HintInputs */

const cs_field_webhook_token_hint = /** @type {(inputs: Field_Webhook_Token_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiřadí se automaticky při uložení. Odesílejte POST požadavky s JSON tělem.`)
};

const en_field_webhook_token_hint = /** @type {(inputs: Field_Webhook_Token_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned automatically when you save. Send POST requests with a JSON body.`)
};

/**
* | output |
* | --- |
* | "Assigned automatically when you save. Send POST requests with a JSON body." |
*
* @param {Field_Webhook_Token_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_webhook_token_hint = /** @type {((inputs?: Field_Webhook_Token_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Webhook_Token_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_webhook_token_hint(inputs)
	return cs_field_webhook_token_hint(inputs)
});